import { render, staticRenderFns } from "./MobileIndustry.vue?vue&type=template&id=44b370fa&scoped=true&"
import script from "./MobileIndustry.vue?vue&type=script&lang=js&"
export * from "./MobileIndustry.vue?vue&type=script&lang=js&"
import style0 from "./MobileIndustry.vue?vue&type=style&index=0&id=44b370fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b370fa",
  null
  
)

export default component.exports